/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseFileHeaderBlock } from './DatabaseFileHeaderBlock';
import {
    DatabaseFileHeaderBlockFromJSON,
    DatabaseFileHeaderBlockFromJSONTyped,
    DatabaseFileHeaderBlockToJSON,
} from './DatabaseFileHeaderBlock';
import type { DatabaseFontSizeEnum } from './DatabaseFontSizeEnum';
import {
    DatabaseFontSizeEnumFromJSON,
    DatabaseFontSizeEnumFromJSONTyped,
    DatabaseFontSizeEnumToJSON,
} from './DatabaseFontSizeEnum';
import type { DatabaseHeaderBlockActionType } from './DatabaseHeaderBlockActionType';
import {
    DatabaseHeaderBlockActionTypeFromJSON,
    DatabaseHeaderBlockActionTypeFromJSONTyped,
    DatabaseHeaderBlockActionTypeToJSON,
} from './DatabaseHeaderBlockActionType';
import type { DatabaseImageHeaderBlockType } from './DatabaseImageHeaderBlockType';
import {
    DatabaseImageHeaderBlockTypeFromJSON,
    DatabaseImageHeaderBlockTypeFromJSONTyped,
    DatabaseImageHeaderBlockTypeToJSON,
} from './DatabaseImageHeaderBlockType';

/**
 * 
 * @export
 * @interface DatabaseImageHeaderBlock
 */
export interface DatabaseImageHeaderBlock extends DatabaseFileHeaderBlock {
    /**
     * 
     * @type {DatabaseImageHeaderBlockType}
     * @memberof DatabaseImageHeaderBlock
     */
    type?: DatabaseImageHeaderBlockType;
    /**
     * 
     * @type {string}
     * @memberof DatabaseImageHeaderBlock
     */
    objectFit?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseImageHeaderBlock
     */
    objectPosition?: string;
    /**
     * FARBE DES ICONS (nur beim Typ ICON).
     * 
     * Betreiber 13.09.2026: „Im Baustein Bild aus Bibliothek kann ich
     * ein Icon waehlen, aber keine Farbe — hier fehlt der
     * Farbpicker." Im Seiten-Baustein gab es die Einstellung danach;
     * im KOPF- und FUSSBEREICH fehlte sie weiter — und zwar nicht
     * nur in der Maske, sondern im Schema: Ein Farbwert waere beim
     * Speichern still verworfen worden.
     * 
     * Ein Icon ist ein Zeichen einer Schriftart; es nimmt Farbe und
     * Groesse des Bausteins (`i { color: inherit; font-size:
     * inherit; }`). Ein BILD traegt seine Farben selbst — dort hat
     * die Angabe keine Wirkung.
     * @type {string}
     * @memberof DatabaseImageHeaderBlock
     */
    fontColor?: string;
    /**
     * 
     * @type {DatabaseFontSizeEnum}
     * @memberof DatabaseImageHeaderBlock
     */
    fontSize?: DatabaseFontSizeEnum;
}

/**
 * Check if a given object implements the DatabaseImageHeaderBlock interface.
 */
export function instanceOfDatabaseImageHeaderBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseImageHeaderBlockFromJSON(json: any): DatabaseImageHeaderBlock {
    return DatabaseImageHeaderBlockFromJSONTyped(json, false);
}

export function DatabaseImageHeaderBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseImageHeaderBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFileHeaderBlockFromJSONTyped(json, ignoreDiscriminator),
        'type': !exists(json, 'type') ? undefined : DatabaseImageHeaderBlockTypeFromJSON(json['type']),
        'objectFit': !exists(json, 'objectFit') ? undefined : json['objectFit'],
        'objectPosition': !exists(json, 'objectPosition') ? undefined : json['objectPosition'],
        'fontColor': !exists(json, 'fontColor') ? undefined : json['fontColor'],
        'fontSize': !exists(json, 'fontSize') ? undefined : DatabaseFontSizeEnumFromJSON(json['fontSize']),
    };
}

export function DatabaseImageHeaderBlockToJSON(value?: DatabaseImageHeaderBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFileHeaderBlockToJSON(value),
        'type': DatabaseImageHeaderBlockTypeToJSON(value.type),
        'objectFit': value.objectFit,
        'objectPosition': value.objectPosition,
        'fontColor': value.fontColor,
        'fontSize': DatabaseFontSizeEnumToJSON(value.fontSize),
    };
}

